import React from 'react';
import {useSearchParams} from 'react-router-dom';
import StoryboardViewContainer from '@/views/storyboard/StoryboardViewContainer';
import useData from '@/utils/useData';
import CellLoader from '@/components/loading/CellLoader';
import i18n from 'i18n';

interface EventsDashboardViewProps {
    storyAssignedUrl?: string;
    activeType?: string;
    activeObject?: string;
    activeObjectType?: string;
}

interface Story {
    id: number;
    assignedUrl: string;
    firstStoryboardHashid: string;
    firstStoryboardSlug: string;
}

const EventsDashboardView: React.FC<EventsDashboardViewProps> = React.memo((
    {
        storyAssignedUrl,
        activeType,
        activeObject,
        activeObjectType,
    },
) => {
    const [searchParams] = useSearchParams();
    const [conversationStories, loadingConversationStories] = useData<Story[]>(window.URLS.storiesResource, {
        storeResolver: 'conversationStories',
        initialValue: [],
        requestParams: {
            params: {storyListType: 'conversationStories'},
        },
    });

    const [personsStories, loadingPersonsStories] = useData<Story[]>(window.URLS.storiesResource, {
        storeResolver: 'personsStories',
        initialValue: [],
        requestParams: {
            params: {storyListType: 'personsStories'},
        },
    });

    if (loadingConversationStories || loadingPersonsStories) {
        return <CellLoader fullHeight={true} />;
    }

    if (storyAssignedUrl) {
        const allStories = [...conversationStories, ...personsStories];
        const story = allStories.find((s: Story) => s.assignedUrl === storyAssignedUrl);

        if (story) {
            const storyboardParam = searchParams.get('storyboard');
            const slugParam = searchParams.get('slug');
            const activeStoryboardHashid = storyboardParam || story.firstStoryboardHashid;
            const activeStoryboardUrl = slugParam || story.firstStoryboardSlug;

            return (
                <StoryboardViewContainer
                    key={`${activeStoryboardHashid}-${activeStoryboardUrl}-${storyAssignedUrl}`}
                    activeStoryboardHashid={activeStoryboardHashid}
                    activeStoryUrl={storyAssignedUrl}
                    activeStoryboardUrl={activeStoryboardUrl}
                    activeStoryObject=""
                    hideNavigation={false}
                />
            );
        }

        // If the story isn't available (e.g. due to missing permissions), show a consistent no-permission message
        return (
            <div className="alert alert-danger" role="alert">
                {i18n.t('tt_you_dont_have_permission_to_access_the_requested_resource.text')}
            </div>
        );
    }

    return (
        <div className="alert alert-danger" role="alert">
            {i18n.t('tt_you_dont_have_permission_to_access_the_requested_resource.text')}
        </div>
    );
});

export default EventsDashboardView;

